<div class="newsletter-page">
  @if (loading) {
    <div>
      <span class="spinner-border spinner-border-sm mr-1"></span>
      {{ 'newsletter.confirming' | t }}
    </div>
  }

  @if (!loading && state) {
    <div class="alert alert-success" id="newsletterConfirmed">
      <h2>{{ 'newsletter.confirmedTitle' | t }}</h2>
      <ul class="lists">
        @if (state.subscribed) {
          <li>{{ 'newsletter.listNewsletter' | t }}</li>
        }
        @if (state.partnerOffers) {
          <li>{{ 'newsletter.listPartnerOffers' | t }}</li>
        }
      </ul>
      <p>{{ 'consents.unsubscribeAnytime' | t }}</p>
      <a class="btn btn-primary" routerLink="/">{{ 'newsletter.backHome' | t }}</a>
    </div>
  }

  @if (!loading && error) {
    <div class="alert alert-danger">
      <h2>{{ 'auth.invalidLink' | t }}</h2>
      <p>{{ error }}</p>
    </div>
  }
</div>
